import { render, staticRenderFns } from "./HeaderMenuChevron.vue?vue&type=template&id=c8e54924"
import script from "./HeaderMenuChevron.vue?vue&type=script&lang=js"
export * from "./HeaderMenuChevron.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports